"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var cnf = {};
cnf.i18n = {
  ns: ['translation'],
  defaultNS: 'translation',
  locales: ['de', 'fr', 'en'],
  preload: ['de', 'fr', 'en'],
  whitelist: ['de', 'fr', 'en'],
  fallbackLng: false,
  saveMissing: false,
  nsSeparator: ':::',
  keySeparator: '::',
  detection: {
    order: ['htmlTag']
  },
  react: {
    wait: false,
    bindI18n: 'languageChanged loaded',
    bindStore: 'added removed',
    nsMode: 'default'
  },
  backend: {
    loadPath: '/static/locales/{{lng}}/{{ns}}.json',
    addPath: '/debug/locales/add/{{lng}}/{{ns}}'
  }
};
var _default = cnf;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/i18n/conf/conf.js
// module id = 461
// module chunks = 0